import { render, staticRenderFns } from "./OrderUpdateHistoryPage.vue?vue&type=template&id=8046998e"
import script from "./OrderUpdateHistoryPage.vue?vue&type=script&lang=js"
export * from "./OrderUpdateHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./OrderUpdateHistoryPage.vue?vue&type=style&index=0&id=8046998e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports